import { render, staticRenderFns } from "./DisciplineList.vue?vue&type=template&id=0d3ee02b"
import script from "./DisciplineList.vue?vue&type=script&lang=js"
export * from "./DisciplineList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports